import React from 'react'
import './style.scss'
import Colors from './../../../styles/Colors'

function ButtonDelete({ load, name = 'Apagar', icon, ...props }) {

    const styleButton = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // backgroundColor: '#ba3030',
        // color: '#FFF',
        // borderColor: '#8B0000'
    }

    return (
        <>
            <button {...props} className="btn btn-outline-warning save-btn" style={styleButton} >
                {
                    <>
                        {
                            name
                        }
                        {
                            icon && icon
                        }
                    </>
                }
            </button>
        </>
    )
}

export default ButtonDelete